export const FURNITURE_CATALOG = Object.freeze([
  Object.freeze({ type: 'bed', label: 'ベッド' }),
  Object.freeze({ type: 'sofa', label: 'ソファ' }),
  Object.freeze({ type: 'table', label: 'テーブル' }),
  Object.freeze({ type: 'chair', label: '椅子' }),
  Object.freeze({ type: 'sideTable', label: 'サイドテーブル' }),
  Object.freeze({ type: 'plant', label: '観葉植物' }),
]);

const TYPES = new Set(FURNITURE_CATALOG.map((item) => item.type));
const round3 = (value) => Math.round(value * 1000) / 1000;

export function normalizeFurnitureLayout(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .filter(
      (item) =>
        item &&
        typeof item.id === 'string' &&
        TYPES.has(item.type) &&
        [item.x, item.y, item.z, item.rot].every((value) => typeof value === 'number' && Number.isFinite(value)),
    )
    .map((item) => ({
      id: item.id,
      type: item.type,
      x: round3(item.x),
      y: round3(item.y),
      z: round3(item.z),
      rot: ((Math.round(item.rot / 90) * 90) % 360 + 360) % 360,
    }));
}

export function addFurniture(layout, type, point) {
  if (!TYPES.has(type)) throw new Error(`家具 ${type} は配置できません`);
  const id = globalThis.crypto?.randomUUID?.() ?? `item-${Date.now()}-${layout.length}`;
  return [...layout, { id, type, x: round3(point.x), y: round3(point.y), z: round3(point.z), rot: 0 }];
}

export function rotateFurniture(layout, id) {
  return layout.map((item) => (item.id === id ? { ...item, rot: (item.rot + 90) % 360 } : item));
}

export function removeFurniture(layout, id) {
  return layout.filter((item) => item.id !== id);
}

export function storageKey(propertyId) {
  return `naiken:furniture:${propertyId}`;
}

export function readFurnitureLayout(storage, propertyId) {
  try {
    return normalizeFurnitureLayout(JSON.parse(storage.getItem(storageKey(propertyId)) ?? '[]'));
  } catch {
    return [];
  }
}

export function writeFurnitureLayout(storage, propertyId, layout) {
  storage.setItem(storageKey(propertyId), JSON.stringify(normalizeFurnitureLayout(layout)));
}
